import { render, staticRenderFns } from "./WordActions.vue?vue&type=template&id=b65662f2&scoped=true&"
import script from "./WordActions.vue?vue&type=script&lang=js&"
export * from "./WordActions.vue?vue&type=script&lang=js&"
import style0 from "./WordActions.scss?vue&type=style&index=0&id=b65662f2&prod&lang=scss&scoped=true&"
import style1 from "./WordActions.vue?vue&type=style&index=1&id=b65662f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65662f2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Definition: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/Definition/Definition.vue').default})
